import { NgModule } from '@angular/core';
import { RouterModule, Routes } from '@angular/router';
import { BackButtonBlockGuard } from './back-button-block.guard';
import { LoginComponent } from './components/pages/login/login.component';
import { VisitorHomeComponent } from './visitor-home/visitor-home.component';
import { VisitorPhoneComponent } from './visitor-phone/visitor-phone.component';
import { VisitorOtpVerificationComponent } from './visitor-otp-verification/visitor-otp-verification.component';
import { VisitorDetailsComponent } from './visitor-details/visitor-details.component';
import { VisitorSelfieComponent } from './visitor-selfie/visitor-selfie.component';
import { VisitorEntryComponent } from './visitor-entry/visitor-entry.component';
import { VisitorCameraComponent } from './visitor-camera/visitor-camera.component';
import { VisitorProofidComponent } from './visitor-proofid/visitor-proofid.component';
import { VisitorThankYouComponent } from './visitor-thank-you/visitor-thank-you.component';

const routes: Routes = [
  { path: '', component: VisitorHomeComponent },

  { path: 'visitor-home/:id', component: VisitorHomeComponent },
  { path: 'visitor-phone', component: VisitorPhoneComponent },
  { path: 'visitor-otp-verification', component: VisitorOtpVerificationComponent, },
  { path: 'visitor-entry', component: VisitorEntryComponent },
  { path: 'visitor-selfie', component: VisitorSelfieComponent },
  { path: 'visitor-details', component: VisitorDetailsComponent },
  { path: 'visitor-camera', component: VisitorCameraComponent },
  { path: 'visitor-proofid', component: VisitorProofidComponent },
  { path: 'visitor-thank-you', component: VisitorThankYouComponent,canDeactivate: [BackButtonBlockGuard], },
];

@NgModule({
  imports: [RouterModule.forRoot(routes)],
  exports: [RouterModule]
})
export class AppRoutingModule { }
